import React from "react"
import strings from "../../localization/strings"
import { Dialog, FlatButton } from "material-ui"
import { IPunchAudit, IRecord } from "../../models"
import AcceptSuspensePunchResultTable from "./AcceptSuspensePunchResultTable"
import ErrorIcon from "material-ui/svg-icons/alert/error"
import SuccessIcon from "material-ui/svg-icons/action/check-circle"
import { green500, red500 } from "material-ui/styles/colors"
interface IProps {
    selectedRecords: IRecord[]
    acceptResult: { string: IPunchAudit }
    handleClose(): void
}

const AcceptSuspensePunchResultDialog: React.SFC<IProps> = (props: IProps) => {
    const notAcceptedPunchAuditCount = props.selectedRecords.map(i => props.acceptResult[i.Punch.Id]).filter(i => i !== null).length
    return (
        <Dialog
            open
            autoScrollBodyContent
            title={strings.Accept_Suspense_Punches_Result}
            titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
            actions={[
                <FlatButton
                    label={strings.OK}
                    primary
                    onClick={props.handleClose}
                />
            ]}
        >
            <div style={{ display: "flex", alignItems: "center", marginLeft: 7, marginBottom: 20 }}>
                {notAcceptedPunchAuditCount ?
                    <ErrorIcon style={{ color: red500, width: 25, height: 25, marginRight: 5 }} /> :
                    <SuccessIcon style={{ color: green500, width: 25, height: 25, marginRight: 5 }} />
                }
                <div>{`${strings.Accepted}: ${props.selectedRecords.length - notAcceptedPunchAuditCount},  ${strings.NotAccepted}: ${notAcceptedPunchAuditCount}`}</div>
            </div>
            <AcceptSuspensePunchResultTable
                selectedRecords={props.selectedRecords}
                acceptResult={props.acceptResult}
            />
        </Dialog>
    )
}

export default AcceptSuspensePunchResultDialog